module.exports = __webpack_public_path__ + "img/XC0717.bb7fc15b.png";